module.exports = __webpack_public_path__ + "static/media/HOMEPAGE.866bc780.png";